import { createMemoStyles } from '@wds/styles';

import { PricingAppTheme } from '~app/styles/pricing/types';

const useIppmStyles = createMemoStyles(({ palette }: PricingAppTheme) => ({
  IPPMWrapper: {
    backgroundColor: palette.background.light,
  },
}));

export default useIppmStyles;
